import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import ProductCard from './ProductCard';
import './ProductsSection.css';
import productsData from '../products.json';

const ProductsSection = () => {
  // جلب البيانات مع التأكد من وجود مفاتيح احتياطية
  const basic = productsData?.basic || {};
  const secondary = productsData?.secondary || {};
  const allCategories = { ...basic, ...secondary };

  const categoryKeys = Object.keys(allCategories);
  const [activeTab, setActiveTab] = useState(categoryKeys[0] || '');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.05 } // خفضنا النسبة لضمان ظهور الأنيميشن فوراً
    );

    if (currentSection) observer.observe(currentSection);

    return () => {
      if (currentSection) observer.unobserve(currentSection);
    };
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
  };

  // المنتجات الحالية المحددة
  const currentCategoryObj = allCategories[activeTab] || {};
  const currentProducts = currentCategoryObj.items || [];
  const totalPages = Math.ceil(currentProducts.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = currentProducts.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <section ref={sectionRef} className="products-section" id="products">
      <Container>
        {/* Title */}
        <div className={`text-center fade-down ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">منتجاتنا</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            استكشف تشكيلتنا الشاملة من أمان المسابح، الشلالات، والنوافير والإكسسوارات
          </p>
        </div>

        {categoryKeys.length > 0 && (
          <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
            {/* Desktop Tabs */}
            <Nav variant="pills" className="d-none d-md-flex justify-content-center mb-5 product-tabs mt-4">
              {categoryKeys.map((key) => (
                <Nav.Item key={key}>
                  <Nav.Link eventKey={key} className="product-tab d-flex align-items-center gap-2">
                    <i className={allCategories[key].icon}></i>
                    <span>{allCategories[key].label}</span>
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>

            {/* Mobile Scroll */}
            <div className="d-md-none mb-4 horizontal-scroll mt-4">
              {categoryKeys.map((key) => (
                <button
                  key={key}
                  className={`product-tab-scroll d-inline-flex align-items-center gap-2 ${
                    activeTab === key ? 'active' : ''
                  }`}
                  onClick={() => handleTabChange(key)}
                >
                  <i className={allCategories[key].icon}></i>
                  <span>{allCategories[key].label}</span>
                </button>
              ))}
            </div>

            {/* Content */}
            <Tab.Content>
              {categoryKeys.map((key) => (
                <Tab.Pane key={key} eventKey={key}>
                  <Row className="g-4" key={`${key}-p-${currentPage}`}>
                    {currentItems.length > 0 ? (
                      currentItems.map((product, idx) => (
                        <Col
                          key={product.id || idx}
                          md={6}
                          lg={4}
                          className="product-card-anim"
                          style={{ animationDelay: `${idx * 0.08}s` }}
                        >
                          <ProductCard {...product} category={key} />
                        </Col>
                      ))
                    ) : (
                      <div className="text-center py-5 text-muted">لا توجد منتجات حالياً في هذا القسم.</div>
                    )}
                  </Row>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="custom-pagination mt-5">
                      <button
                        className="page-nav-btn"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                      >
                        <i className="fas fa-chevron-right"></i>
                      </button>

                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                          key={page}
                          className={`page-number-btn ${currentPage === page ? 'active' : ''}`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      ))}

                      <button
                        className="page-nav-btn"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                      >
                        <i className="fas fa-chevron-left"></i>
                      </button>
                    </div>
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        )}
      </Container>
    </section>
  );
};

export default ProductsSection;